function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#E8ECFF",
  opacity: 0.408
}, /*#__PURE__*/React.createElement("path", {
  d: "M42.825 79.953c8.937 0 15.372.864 21.802-4.847 5.335-4.738 8.427-3.58 10.726-10.819C76.683 60.1 80 44.681 80 40c0-15.982-6.626-22.335-18.891-29.025C56.087 8.235 44.632 0 38.636 0c-6.83 0-15.934.125-21.443 3.616C10.758 7.694 4.097 16.22.837 23.563c-2.384 5.37 1.081 17.288 1.081 23.655 0 7.937 15.817 10.563 22.16 17.069 6.345 6.507 5.47 11.033 9.036 12.849 4.434 2.26.775 2.817 9.711 2.817z",
  transform: "translate(-644 -230) translate(301 79) translate(343 151)"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-644 -230) translate(301 79) translate(343 151) translate(3 3) translate(3 3)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#E8EDFC",
  d: "M51.967 29c.022-.44.033-.882.033-1.327C52 15.703 43.941 6 34 6s-18 9.703-18 21.673c0 .445.011.888.033 1.327H9.051C9.017 28.417 9 27.831 9 27.241 9 12.197 20.193 0 34 0s25 12.197 25 27.242c0 .59-.017 1.176-.051 1.757z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#428DFF",
  d: "M34 0c13.807 0 25 12.984 25 29S47.807 58 34 58 9 45.016 9 29 20.193 0 34 0zm0 1.871C21.297 1.871 11 14.017 11 29s10.297 27.129 23 27.129S57 43.983 57 29 46.703 1.871 34 1.871zM34 5c11.046 0 20 10.745 20 24s-8.954 24-20 24-20-10.745-20-24S22.954 5 34 5zm0 1.882c-9.941 0-18 9.903-18 22.118 0 12.215 8.059 22.118 18 22.118S52 41.215 52 29c0-12.215-8.059-22.118-18-22.118z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E8EDFC",
  stroke: "#428DFF",
  strokeWidth: 2,
  d: "M59 28c.828 0 1.578.336 2.121.879.543.543.879 1.293.879 2.121h0v32c0 .828-.336 1.578-.879 2.121-.543.543-1.293.879-2.121.879h0H9c-.828 0-1.578-.336-2.121-.879C6.336 64.578 6 63.828 6 63h0V31c0-.828.336-1.578.879-2.121C7.422 28.336 8.172 28 9 28h0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E8EDFC",
  stroke: "#428DFF",
  strokeWidth: 2,
  d: "M64 37c.828 0 1.578.336 2.121.879.543.543.879 1.293.879 2.121h0v9c0 .828-.336 1.578-.879 2.121-.543.543-1.293.879-2.121.879h0H4c-.828 0-1.578-.336-2.121-.879C1.336 50.578 1 49.828 1 49h0v-9c0-.828.336-1.578.879-2.121C2.422 37.336 3.172 37 4 37h0z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 8,
  height: 2,
  x: 11,
  y: 44,
  fill: "#428DFF",
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 8,
  height: 2,
  x: 24,
  y: 44,
  fill: "#428DFF",
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 8,
  height: 2,
  x: 37,
  y: 44,
  fill: "#428DFF",
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 8,
  height: 2,
  x: 50,
  y: 44,
  fill: "#428DFF",
  rx: 1
}))));

function SvgIconLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/icon-lock.b69d5bb5.svg";
export { ForwardRef as ReactComponent };